import { theme } from "./theme";

export const useTheme = () => {
  return theme;
};
